/* eslint-disable import/prefer-default-export */

export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
// export const API_BASE_URL = IS_PRODUCTION ? 'https://paperboy-api.here.cl' : 'http://localhost:40002';
export const API_BASE_URL = IS_PRODUCTION ? 'https://paperboy-api.grow.mobi' : 'https://paperboy-api.grow.mobi';
